import { IRawStyle } from '@fluentui/react';
import { globalPaddingScene } from 'globalStyles';

export const wizardContentWidth: string = 'min(92vw, 680px)';
//one fixed height for both steps, so the window does not jump when the step or the AI result
//changes; long content (many AI steps or controls) scrolls inside the body
export const wizardHeight: string = 'min(85vh, 820px)';
//room for the longest step label ("Wie en wanneer", "Who and when", "Wer und wann")
export const wizardStepLabelWidth: number = 130;
export const wizardBodyMinHeight: number = 340;
//the checklist fills the free space in step 1 and scrolls inside its own pane below this height;
//the height includes its label, progress bar and add field, so about 4 rows stay visible
export const wizardChecklistMinHeight: number = 420;

//header and footer stay put; only the body scrolls
export const getWizardRootStyles = (): IRawStyle => {
  return {
    width: wizardContentWidth,
    height: wizardHeight,
    boxSizing: 'border-box',
    position: 'relative',
  };
};

export const getWizardBodyStyles = (): IRawStyle => {
  return {
    minHeight: wizardBodyMinHeight,
    minWidth: 0,
    boxSizing: 'border-box',
    padding: globalPaddingScene,
    overflowX: 'hidden',
    overflowY: 'auto',
  };
};

export const getWizardSectionStyles = (): IRawStyle => {
  return {
    padding: `0 ${globalPaddingScene}px`,
    boxSizing: 'border-box',
  };
};
